
// styled-components based extension
import styled, { css } from 'styled-components'
import { Box, Flex } from '@magicsoup.io/stock'
import { themeGet } from 'styled-system'

const Mission = styled(Box)`
  
`
const Content = styled.div( props => css`
  
`)

Content.defaultProps = {
  as: 'div',
  py: '4',
}

Mission.defaultProps = {
  as: 'div',
}

export default Mission